﻿<template>
  <div class="cart-summary md:mx-4">
    <div class="basket-summary" x-data="{ open: false }">
      <itinerary_breakdown></itinerary_breakdown>

      <div class="summary-total section">
        <div class="row">
          <h6 class="title text-base text-heading font-bold">Price</h6>
          <p class="balance text-2xl text-black text-action font-bold mb-0">{{ get_Trip_Total() }} <span class="font-normal text-lg">{{ get_Curreny_Code()+" " }}</span><small class="font-normal text-sm">includes all taxes.</small></p>
          <p v-if="!get_Booking_Summary().includes('Please select passenger')" class="basket-summary-text text-sm mt-2 mb-0" v-html="get_Booking_Summary()"></p>
        </div>
      </div>
      <div class="summary-action section">
        <div class="row">
          <button type="button" v-if="!$store.getters.get_isQuoteCalculating && !get_Booking_Summary().includes('Please select passenger') && isBookable()" class="button button-pink-book full" :class="{ hidden: !isBookable() }" @click="Add_To_Cart()">
            Add to Cart
          </button>

          <div v-if="$store.getters.get_isQuoteCalculating" class="tc-quote-loading" role="status" aria-label="Calculating price">
            <svg class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
          </div>
          <span :class="{ hidden: isBookable() }">Please select passengers and departure date to proceed and see price.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="./basket.ts"></script>
